import React, { Fragment } from "react";
import { formatValidationError } from "utils/form";
import { useFormikContext } from "formik";
import Textarea from "components/Form/fields/Textarea";
import Label from "components/Form/fields/Label";
import get from "lodash/get";

const ConnectedTextarea = ({
  name,
  label,
  error,
  hideError,
  required,
  ...remainder
}) => {
  const { touched, errors } = useFormikContext();
  const ctxError = error || get(errors, name);
  const isTouched = get(touched, name);
  const showError = Boolean(isTouched && ctxError);

  return (
    <Fragment>
      {label && <Label label={label} error={showError} required={required} />}
      <Textarea name={name} {...remainder} />
      {showError && !hideError && (
        <div className="f7 pt1 color-error">
          {formatValidationError(ctxError)}
        </div>
      )}
    </Fragment>
  );
};

export default ConnectedTextarea;
